import { render, staticRenderFns } from "./SaveAsPreset.vue?vue&type=template&id=9c335866&"
import script from "./SaveAsPreset.vue?vue&type=script&lang=js&"
export * from "./SaveAsPreset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports